const e = {
  id: "LottoAmerica",
  name: "Lotto America",
  style: {
    colorPrimary: "#ee3124",
    extraBall: {
      bg: "#ee3124",
      color: "#ffffff",
      fontSize: "0.4375rem",
      fontWeight: 700
    }
  }
};
export {
  e as default
};
